import type {
  PayrollRoster,
  PayrollRosterDraftMember,
} from "@/payroll/roster/types";

type RosterSuggestionsSource = Pick<
  PayrollRoster,
  "members" | "missing_user_suggestions" | "removed_member_external_ids"
>;

export const getPayrollRosterSuggestions = (
  roster: RosterSuggestionsSource,
) => {
  const memberIds = new Set(
    roster.members.map((member) => member.service_titan_employee_id),
  );
  const dismissedIds = new Set(roster.removed_member_external_ids ?? []);

  return (roster.missing_user_suggestions ?? []).filter(
    ({ service_titan_employee_id }) =>
      !memberIds.has(service_titan_employee_id) &&
      !dismissedIds.has(service_titan_employee_id),
  );
};

export const createPayrollRosterSuggestionDrafts = (
  roster: RosterSuggestionsSource,
): PayrollRosterDraftMember[] =>
  getPayrollRosterSuggestions(roster).map((suggestion) => {
    const {
      service_titan_employee_id,
      display_name,
      user_id,
      team_access_key_ids,
      field_values,
    } = suggestion;

    return {
      id: `suggestion-${user_id}`,
      isNew: true,
      member: {
        service_titan_employee_id,
        display_name,
        user_id,
        team_access_key_ids,
        field_values: { ...field_values },
      },
      suggestion,
    };
  });
